/* tslint:disable */
/* eslint-disable */
export enum LengthUnit {
  None = 'None',
  Metres = 'Metres',
  Feet = 'Feet'
}
